"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.find");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ConfigUtils = /*#__PURE__*/function () {
  function ConfigUtils() {
    _classCallCheck(this, ConfigUtils);
  }

  _createClass(ConfigUtils, null, [{
    key: "zipWithContent",

    /**
     * Merge content into a form config
     * Note the content "section key(s)" must match a "form config section id" to merge.
     *
     * Additional content, ie. titles and descriptions that are not part
     * of the "section key(s)" can be directly merged via the "titleFields" key containing
     * an object with a section id and the content field data.
     *
     * It is possible for the <TiledOptionGroup> to contain multi-line content. See the
     * readme.jsx for the component for the form config and content setup. Content for each
     * option must its own field with the key prefaced with "option__", ie. the key will be
     * `option__${formConfigOptionId}`. This will ensure seamless content merging - lines 47-68.
     *
     * @example
     * const content = { "exampleSection": [{key: "field1", "label": "A Field"}], "titleFields": { key: contentField } }
     * const config = { sections: [ { id: "exampleSection", fields: [ { key: "field1", "type": "text" } ] } ] }
     *
     * const mergedConfig = ConfigUtils.zipWithContent(config, content);
     *
     * @param config
     * @param content
     * @returns {*}
     */
    value: function zipWithContent(config, content) {
      if (!content) {
        return;
      }

      var _mapFields = function _mapFields(fields, fieldsContent) {
        fields.forEach(function (field) {
          var fieldContent = fieldsContent.find(function (el) {
            return el.key === field.id;
          });

          if (!fieldContent) {
            if (process.env.NODE_ENV !== 'production') {
              if (field.type !== 'hidden') {
                console.warn("No content defined for field: ".concat(field.id));
              }
            }

            return;
          }

          field.label = fieldContent.label;
          field.inputFormatSuggestion = fieldContent.inputFormatSuggestion;
          field.tooltip = fieldContent.tooltip;
          field.placeholder = fieldContent.placeholder;
          field.helpText = fieldContent.helpText;
          field.autocomplete = fieldContent.autocomplete; // Map content for multi-line Tiled Option Group options

          if (field.type === 'tiled-radio' && field.options && field.options.length) {
            var options = field.options;
            options.forEach(function (option) {
              // Check for multi-line text
              if (option.helpText) {
                var optionContent = fieldsContent.find(function (el) {
                  return el.key === "option__".concat(option.id);
                });

                if (optionContent) {
                  option.label = optionContent.label;
                  option.helpText = optionContent.helpText;
                } else {
                  if (process.env.NODE_ENV !== 'production') {
                    console.warn("No content defined for option: ".concat(option.id));
                  }
                }
              }
            });
          } // Map regular options with content
          // This will also merge single line Tiled Option Group options


          if (field.options && field.options.length && fieldContent.options && fieldContent.options.length) {
            field.options.map(function (opt) {
              var matchingOption;

              if (opt.contentKey) {
                matchingOption = fieldContent.options.find(function (o) {
                  return o.key === opt.contentKey;
                });
              } else {
                matchingOption = fieldContent.options.find(function (o) {
                  return o.key === opt.value;
                });
              }

              if (matchingOption !== undefined) {
                opt.label = matchingOption.label;
                opt.helpText = matchingOption.helpText;
              }
            });
          }
        });
      }; // Map fields content


      if (config.fields) {
        _mapFields(config.fields, content);
      } // Map section fields content


      if (config.sections) {
        config.sections.forEach(function (section) {
          // Replace section titles and descriptions with content
          if (section.title && _typeof(content.titleFields) === 'object' && content.titleFields[section.id]) {
            section.title = content.titleFields[section.id].title;
          }

          if (section.description && content.titleFields) {
            section.description = content.titleFields[section.id].text;
          }

          var sectionContent = content[section.id];

          if (!sectionContent) {
            if (section.id !== 'meta') {
              if (process.env.NODE_ENV !== 'production') {
                console.warn("No content defined for section: ".concat(section.id));
              }
            }

            return;
          } // Replace fields with content


          _mapFields(section.fields, sectionContent);
        });
      }

      return config;
    }
    /**
     * Merge content into a form config
     * @alias
     */

  }, {
    key: "merge",
    value: function merge(config, content) {
      return ConfigUtils.zipWithContent(config, content);
    }
    /**
     * Merge a fields array directly into a config section
     * @example
     * const fields = [{key: "field1", "label": "A Field"}];
     * const config = { sections: [ { id: "exampleSection", fields: [ { key: "field1", "type": "text" } ] } ] }
     *
     * const mergedConfig = ConfigUtils.mergeFieldsIntoSection(config, fields, 'exampleSection');
     *
     * @param config
     * @param fields
     * @param sectionId
     * @returns {*}
     */

  }, {
    key: "mergeFieldsIntoSection",
    value: function mergeFieldsIntoSection(config, fields, sectionId) {
      var _content = {};
      _content[sectionId] = fields;
      return ConfigUtils.merge(config, _content);
    }
  }]);

  return ConfigUtils;
}();

exports.default = ConfigUtils;
//# sourceMappingURL=ConfigUtils.js.map